import { render, staticRenderFns } from "./DeviceTransferList.vue?vue&type=template&id=55802433&scoped=true&"
import script from "./DeviceTransferList.vue?vue&type=script&lang=js&"
export * from "./DeviceTransferList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTransferList.vue?vue&type=style&index=0&id=55802433&lang=scss&scoped=true&"
import style1 from "./DeviceTransferList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55802433",
  null
  
)

export default component.exports